<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jeMXLn/tc-custom/9781631940118.jpg?1704318767418" alt="This image is the cover for the book Death of a Hollow Man, Inspector Barnaby Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Death of a Hollow Man, Inspector Barnaby Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>An onstage murder in a small English village draws the beloved detective into “a theatrical whodunit worthy of a deep bow” (<i>The New York Times</i>).</b><br/><br/>Actors do love their dramas, and the members of the Causton Amateur Dramatic Society are no exception. However, even the most theatrically minded have to admit that murdering the leading man in full view of the audience is a bit over the top. Luckily, Inspector Barnaby is in that audience, and while he may lack certain skills as a theater critic, he’s just the man to catch a killer.<br/><br/>In this second Barnaby mystery, the inspector is in his element, and so is author Caroline Graham, a former actress, who tweaks her collection of community-theater artistes and small-town drama queens with merciless delight. <i>Death of a Hollow Man</i> was the basis for the second episode in season one of the acclaimed ITV crime drama <i>Midsomer Murders</i>.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Caroline Graham
      </h2>
      
      <p class="authorDescription body article">Caroline Graham is a British mystery novelist and screenwriter best known for the &quot;Inspector Barnaby&quot; mystery series which became the basis for the long-running &quot;Midsomer Murders&quot; TV series</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Felony & Mayhem Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?562e834a